import { ticketSalesList } from "@/helpers/service/api/ticketSales";
import { json2csv_fn, toThousands } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from 'moment';
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";


export function exportCSV_fn(requestParma) {
  ticketSalesList(requestParma).then(res => {
    if (res.data.nationalTicket.length > 0 || res.data.advanceTicket.length > 0) {
      let csvData = [];
      const fields = [
        {
          label: locale("report.ticketSales.ticketType"),
          value: "name",
        },
        {
          label: locale("couponLib.ticketType"),
          value: "ticketType",
        },
        {
          label: locale("trans.other.price"),
          value: "amount",
        },
        {
          label: locale("global.quantity"),
          value: "qty",
        },
        {
          label: locale("accPayMDetail.total"),
          value: "allTotal",
        },
      ];
      res.data.nationalTicket.forEach(item => {
        csvData.push({
          name: locale("cashierReport.dialog.nationalTicket"),
          ticketType: item.ticketType,
          amount: toThousands(item.amount),
          qty: item.qty,
          allTotal: toThousands(item.allTotal)
        });
      });
      if (res.data.nationalTicket.length > 0) {
        csvData.push({
          name: locale("report.ticketSales.mvtkSubTotal"),
          ticketType: "",
          amount: toThousands(res.data.nationalTicket.reduce((total, item) => total + item.amount, 0)),
          qty: res.data.nationalTicket.reduce((total, item) => total + item.qty, 0),
          allTotal: toThousands(res.data.nationalTicket.reduce((total, item) => total + item.allTotal, 0)),
        });
      }
      res.data.advanceTicket.forEach(item => {
        csvData.push({
          name: locale("cashierReport.dialog.advanceCoupon"),
          ticketType: item.ticketType,
          amount: toThousands(item.amount),
          qty: item.qty,
          allTotal: toThousands(item.allTotal)
        });
      });
      if (res.data.advanceTicket.length > 0) {
        csvData.push({
          name: locale("report.ticketSales.advanceSubTotal"),
          ticketType: "",
          amount: toThousands(res.data.advanceTicket.reduce((total, item) => total + item.amount, 0)),
          qty: res.data.advanceTicket.reduce((total, item) => total + item.qty, 0),
          allTotal: toThousands(res.data.advanceTicket.reduce((total, item) => total + item.allTotal, 0)),
        });
      }
      csvData.push({
        name: locale("report.ticketSales.allTotal"),
        ticketType: "",
        amount: toThousands(res.data.advanceTicket.reduce((total, item) => total + item.amount, 0) + res.data.nationalTicket.reduce((total, item) => total + item.amount, 0)),
        qty: res.data.advanceTicket.reduce((total, item) => total + item.qty, 0) + res.data.nationalTicket.reduce((total, item) => total + item.qty, 0),
        allTotal: toThousands(res.data.advanceTicket.reduce((total, item) => total + item.allTotal, 0) + res.data.nationalTicket.reduce((total, item) => total + item.allTotal, 0)),
      });
      const { startDate, endDate } = requestParma
      json2csv_fn(csvData, fields,
        // moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.ticketSales")
        getExportName_fn(
          locale("sideMenu.reports.ticketSales"),
          '',
          '',
          '',
          `${moment(startDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(endDate).day()]}）`,
          res.data.cinemaName,
          moment().format('YYYYMMDDHHmm')
        )
      );
    }
  });
}